/* =========================================================================
   couplezine — Sticky-Kaufleiste: Preis folgt der aktuellen Auswahl
   (Bundle vs. Einzelkauf, Abo vs. Einmalig, gewählte Variante).
   ========================================================================= */
(function () {
  'use strict';
  window.__syncStickyPrice = function () {
    var sticky = document.getElementById('sticky-price');
    if (!sticky) return;
    var compare = document.querySelector('.pdp-sticky__compare');

    // 1) Bundle gewählt -> Bundle-Preis (+ Streichpreis) übernehmen
    var root = document.getElementById('pdp-bundle');
    if (root && root.dataset.selected === 'bundle') {
      var now = root.querySelector('.pbo--bundle .pbo__now');
      var was = root.querySelector('.pbo--bundle .pbo__was');
      if (now && now.textContent.trim()) {
        sticky.textContent = now.textContent.trim();
        if (compare) compare.textContent = was ? was.textContent.trim() : '';
        return;
      }
    }

    // 2) Einzelkauf: Abo/Einmalig-Auswahl (falls vorhanden), sonst Kaufbox-Preis
    var pseg = document.querySelector('#purchase-pick .pseg__opt.is-active .pseg__price strong');
    var buySale = document.getElementById('buy-sale');
    var src = pseg || buySale;
    if (src && src.textContent.trim()) sticky.textContent = src.textContent.trim();
    var buyCompare = document.querySelector('.buy__compare');
    if (compare) compare.textContent = (buyCompare && buyCompare.textContent.trim()) ? buyCompare.textContent.trim() : '';
  };
})();

/* =========================================================================
   couplezine — enhance.js
   Additive Animations-Schicht. Greift NICHT in bestehende Logik ein.
   - Scroll-Reveals via IntersectionObserver
   - Klick-/Tap-Pop-Feedback
   - Warenkorb-Badge-Bump bei Mengenänderung
   - Weiches Einblenden von Bildern
   Respektiert prefers-reduced-motion vollständig.
   ========================================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     1 · Reveal-Ziele automatisch markieren (ohne Markup zu ändern)
     --------------------------------------------------------------------- */
  function tagReveals() {
    // Sektions-Überschriften
    document.querySelectorAll('.section-head').forEach(function (el) {
      el.classList.add('reveal');
    });

    // Container, deren Kinder gestaffelt aufploppen sollen
    // Container, deren Kinder gestaffelt aufploppen sollen.
    // Bewusst OHNE die horizontal scrollenden Rails (.rail, .community__rail),
    // damit deren Touch-Scrolling absolut flüssig bleibt.
    var staggerSelectors = [
      '.reviews__grid',
      '.notes__grid',
      '.how__steps',
      '.bundle__grid',
      '.assure'
    ];
    staggerSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('reveal', 'reveal-stagger');
      });
    });

    // Einzelne größere Blöcke, die als Ganzes einschweben
    var blockSelectors = [
      '.bundle__card',
      '.newsletter__card',
      '.faq',
      '.how',
      '.notes',
      '.reviews',
      '.community',
      '.benefits'
    ];
    blockSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // nicht doppelt taggen, wenn schon ein Stagger-Container
        if (!el.classList.contains('reveal-stagger')) {
          el.classList.add('reveal');
        }
      });
    });
  }

  /* ---------------------------------------------------------------------
     2 · IntersectionObserver schaltet .is-in
     --------------------------------------------------------------------- */
  function observeReveals() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
     3 · Tap-Pop-Feedback auf Buttons & klickbaren Elementen
     --------------------------------------------------------------------- */
  function wireTapPop() {
    if (reduce) return;
    var sel = '.btn, .add, .gthumb, .ci__qty button';
    document.addEventListener('click', function (e) {
      var t = e.target.closest(sel);
      if (!t) return;
      t.classList.remove('tap-pop');
      // reflow, damit die Animation erneut startet
      void t.offsetWidth;
      t.classList.add('tap-pop');
      setTimeout(function () { t.classList.remove('tap-pop'); }, 450);
    }, { passive: true });
  }

  /* ---------------------------------------------------------------------
     4 · Warenkorb-Badge hüpft, wenn sich der Zähler ändert
     --------------------------------------------------------------------- */
  function watchCartCount() {
    if (reduce) return;
    var badge = document.getElementById('cart-count');
    if (!badge || !('MutationObserver' in window)) return;

    var last = badge.textContent;
    var mo = new MutationObserver(function () {
      if (badge.textContent !== last) {
        last = badge.textContent;
        badge.classList.remove('bump');
        void badge.offsetWidth;
        badge.classList.add('bump');
      }
    });
    mo.observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* ---------------------------------------------------------------------
     5 · Bilder weich einblenden, sobald geladen
     --------------------------------------------------------------------- */
  function fadeInImages() {
    if (reduce) return;
    document.querySelectorAll('img').forEach(function (img) {
      // Hero-Hintergrund & schon geladene überspringen
      if (img.complete && img.naturalWidth > 0) return;
      img.style.opacity = '0';
      img.style.transition = 'opacity .5s ease';
      var shown = false;
      var show = function () {
        if (shown) return;
        shown = true;
        img.style.opacity = '1';
      };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
      // Sicherheitsnetz: falls das load-Event nie feuert (Cache-Race,
      // lazy-Bild, das nie in den Viewport kommt), Bild trotzdem zeigen.
      if (img.complete) { show(); }
    });
  }

  /* ---------------------------------------------------------------------
     Init — auch bei Shopify-Theme-Editor-Neuladevorgängen robust
     --------------------------------------------------------------------- */
  function init() {
    tagReveals();
    observeReveals();
    wireTapPop();
    watchCartCount();
    fadeInImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Section-Rendering (Theme-Editor): neue Inhalte erneut taggen
  document.addEventListener('shopify:section:load', function () {
    tagReveals();
    observeReveals();
  });
})();

/* =========================================================================
   couplezine — Varianten-Auswahl (additive Schicht)
   Verbindet die echten Produktvarianten mit der reinperle-Kaufbox.
   - Liest die Varianten aus #product-variants-data (JSON von Shopify)
   - Aktualisiert beim Auswählen: #buy-add (data-variant), Preis, Sticky-Bar
   - Nutzt dieselben data-Attribute, die script.js bereits liest
   ========================================================================= */
(function () {
  'use strict';

  function formatEuro(cents) {
    // An das Shop-Format angleichen (siehe snippets/price-eur.liquid):
    // Eurozeichen NACH der Zahl, ganze Beträge ohne Nachkommastellen,
    // sonst mit zwei Nachkommastellen und Komma.
    var euros = (cents || 0) / 100;
    var rounded = Math.round(euros * 100) / 100;
    if (Math.round(rounded) === rounded) {
      return rounded.toLocaleString('de-DE') + ' €';
    }
    return rounded.toLocaleString('de-DE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' €';
  }

  function initVariantPicker() {
    var dataEl = document.getElementById('product-variants-data');
    var buyAdd = document.getElementById('buy-add');
    if (!dataEl || !buyAdd) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); }
    catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var optionGroups = Array.prototype.slice.call(
      document.querySelectorAll('.vswatches')
    );
    if (!optionGroups.length) return;

    // aktuell gewählte Optionswerte je Option-Index
    var selected = [];
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      var active = group.querySelector('.vswatch.is-active');
      if (active) selected[idx] = active.dataset.optionValue;
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        for (var i = 0; i < optionGroups.length; i++) {
          var idx = parseInt(optionGroups[i].dataset.optionIndex, 10);
          if (selected[idx] == null) return false;
          if (opts[idx] !== selected[idx]) return false;
        }
        return true;
      });
    }

    function applyVariant(v) {
      if (!v) return;
      // Kauf-Button aktualisieren
      buyAdd.dataset.variant = v.id;
      // Preisdaten für die optimistische Warenkorb-Anzeige aktuell halten
      buyAdd.dataset.price = v.price;
      buyAdd.dataset.compare = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
      // echtes Formularfeld (für Apps, die das Produkt-Formular auslesen)
      var idInput = document.querySelector('#product-form input[name="id"]');
      if (idInput) idInput.value = v.id;
      // Preis (Kaufbox)
      var saleEl = document.getElementById('buy-sale');
      if (saleEl) saleEl.textContent = formatEuro(v.price);
      // Vergleichspreis / Rabatt-Badge
      var compareEl = document.querySelector('.buy__compare');
      var offEl = document.querySelector('.buy__off');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (compareEl) compareEl.textContent = formatEuro(v.compare_at_price);
        if (offEl) {
          var pct = Math.round(
            (v.compare_at_price - v.price) * 100 / v.compare_at_price
          );
          offEl.textContent = '-' + pct + ' %';
        }
      } else {
        if (compareEl) compareEl.textContent = '';
        if (offEl) offEl.textContent = '';
      }
      // Button-Zustand bei Nichtverfügbarkeit. WICHTIG: Nur das Haupt-Label
      // (.buy__add-main) ändern, damit die zweite Zeile (.buy__add-sub) und die
      // Struktur des Buttons erhalten bleiben. buyAdd.textContent würde beide
      // Spans löschen.
      var mainLabel = buyAdd.querySelector('.buy__add-main');
      if (v.available === false) {
        buyAdd.setAttribute('disabled', 'disabled');
        if (mainLabel) mainLabel.textContent = 'ausverkauft';
        else buyAdd.textContent = 'ausverkauft';
      } else {
        buyAdd.removeAttribute('disabled');
        if (mainLabel) mainLabel.textContent = 'In den Warenkorb legen';
        else buyAdd.textContent = 'In den Warenkorb legen';
      }
      // Sticky-Leiste zentral aktualisieren (Bundle hat Vorrang vor Variantenpreis)
      if (typeof window.__syncStickyPrice === 'function') window.__syncStickyPrice();
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.vswatch');
        if (!btn) return;
        var idx = parseInt(group.dataset.optionIndex, 10);
        selected[idx] = btn.dataset.optionValue;
        group.querySelectorAll('.vswatch').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        applyVariant(findVariant());
      });
    });

    // Initialzustand anwenden
    applyVariant(findVariant());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPicker);
  } else {
    initVariantPicker();
  }
  document.addEventListener('shopify:section:load', initVariantPicker);
})();

/* =========================================================================
   couplezine — eigenständige PDP-Bundle-Section
   - Bundle-Liquid bleibt separat in sections/pdp-bundle.liquid
   - Section wird mobilfreundlich in den Slot über dem bestehenden Warenkorb-Button verschoben
   - Der bestehende Warenkorb-Button fügt je nach Auswahl Einzelprodukt oder Bundle hinzu
   ========================================================================= */
(function () {
  'use strict';

  function uniqueIds(raw) {
    return (raw || '')
      .split(',')
      .map(function (value) { return value.trim(); })
      .filter(Boolean)
      .filter(function (value, index, arr) { return arr.indexOf(value) === index; });
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function moveBundleIntoSlot(root) {
    var slot = document.getElementById('pdp-bundle-slot');
    if (!root || !slot) return;
    var carrier = root.closest('.shopify-section') || root;
    if (slot.contains(carrier)) return;
    slot.appendChild(carrier);
  }

  function setSelected(root, options, value) {
    root.dataset.selected = value || 'single';
    options.forEach(function (option) {
      var active = option.dataset.option === root.dataset.selected;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    // Sticky-Kaufleiste an die Auswahl anpassen (z.B. Bundle-Preis anzeigen)
    if (typeof window.__syncStickyPrice === 'function') window.__syncStickyPrice();
  }


  function formatCountdown(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    function pad(value) { return String(value).padStart(2, '0'); }
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function msUntilWindowEnd() {
    // Gleiche Zeitfenster wie die Ankündigungsleiste: 0–12, 12–15, 15–20, 20–24 Uhr.
    // Zählt jeweils bis zum Ende des aktuellen Fensters.
    var now = new Date();
    var windowEnds = [12, 15, 20, 24];
    var curHour = now.getHours();
    var endHour = 24;
    for (var i = 0; i < windowEnds.length; i++) {
      if (curHour < windowEnds[i]) { endHour = windowEnds[i]; break; }
    }
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    end.setHours(endHour, 0, 0, 0);
    return end.getTime() - now.getTime();
  }

  function initBundleCountdown(root) {
    if (!root) return;
    var badge = root.querySelector('[data-pbx-countdown]');
    if (!badge || badge.dataset.countdownReady === '1') return;
    badge.dataset.countdownReady = '1';

    var prefix = badge.dataset.countdownPrefix || 'Endet in';
    function update() {
      badge.textContent = prefix + ' ' + formatCountdown(msUntilWindowEnd());
    }

    update();
    window.setInterval(update, 1000);
  }

  function selectedIds(root) {
    var raw = root.dataset.selected === 'bundle' ? root.dataset.bundleVids : root.dataset.singleVids;
    var ids = uniqueIds(raw);
    var mainAdd = document.getElementById('buy-add');
    var currentVariant = mainAdd && mainAdd.dataset && mainAdd.dataset.variant;
    if (ids.length && currentVariant) ids[0] = currentVariant;
    return uniqueIds(ids.join(','));
  }

  function setMainLoading(btn, state) {
    if (!btn) return;
    if (state) {
      btn.dataset.originalText = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.innerHTML = 'wird hinzugefügt …';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.innerHTML = btn.dataset.originalText || 'in den warenkorb legen';
    }
  }

  function addSelectedBundle(root, button) {
    var ids = selectedIds(root);
    var sellingPlan = button && button.dataset ? button.dataset.sellingPlan : '';
    var isBundle = root.dataset.selected === 'bundle';
    var paidIds = uniqueIds(root.dataset.bundlePaidVids || '');
    var freeIds = uniqueIds(root.dataset.bundleFreeVids || '');
    var currentVariant = button && button.dataset ? button.dataset.variant : '';
    if (isBundle && paidIds.length && currentVariant) paidIds[0] = String(currentVariant);
    var bundleId = isBundle ? ('mf_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8)) : '';
    var requiredPaid = isBundle ? uniqueIds(paidIds.join(',')).join(',') : '';
    var title = root.dataset.bundleTitle || 'Couplezine Bundle';

    var appProps = (typeof window.collectLineItemProperties === 'function')
      ? window.collectLineItemProperties()
      : null;

    var items = ids.map(function (id, index) {
      var idString = String(id);
      var item = { id: Number(id), quantity: 1 };
      if (index === 0 && sellingPlan) item.selling_plan = Number(sellingPlan);
      if (isBundle && bundleId) {
        item.properties = {
          '_mf_bundle_id': bundleId,
          '_mf_bundle_title': title,
          '_mf_bundle_role': freeIds.indexOf(idString) !== -1 ? 'free' : 'paid',
          '_mf_bundle_required_paid': requiredPaid
        };
      }
      // Upload-/App-Eigenschaften (z.B. Uploadly-Datei) gehören ans Hauptprodukt
      if (index === 0 && appProps) {
        item.properties = Object.assign({}, appProps, item.properties || {});
      }
      return item;
    }).filter(function (item) {
      return item.id && !isNaN(item.id);
    });

    // BUGFIX: Beim Einzelkauf ("kleines" Paket) wird die Gratis-Anleitung in der
    // Option beworben, fehlte aber im Warenkorb & Checkout — die Bundle-Auswahl
    // übersteuert den normalen Kauf-Flow (der die Anleitung mitgibt) und hängte
    // sie bisher nur beim großen Bundle an. Jetzt kommt sie auch hier als
    // Gratis-Position mit (0 € über den automatischen Shopify-Rabatt, wie beim
    // großen Bundle und beim normalen Einzelkauf).
    if (!isBundle && items.length) {
      var guideVid = root.dataset.guideVid || document.body.getAttribute('data-free-guide-variant') || '';
      var alreadyIn = items.some(function (it) { return String(it.id) === String(guideVid); });
      if (guideVid && !alreadyIn) {
        items.push({
          id: Number(guideVid),
          quantity: 1,
          properties: { '_mf_free_guide': '1', '_mf_bundle_role': 'free' }
        });
      }
    }

    if (!items.length) return Promise.resolve();

    setMainLoading(button, true);
    if (typeof window.openCart === 'function') window.openCart();

    // SOFORT-FEEDBACK (0 ms) beim Einzelkauf: Hauptprodukt + Gratis-Anleitung
    // direkt anzeigen (Daten von Kauf-Button/body). Beim großen Bundle sind
    // die weiteren Positionen clientseitig nicht bekannt — dort übernimmt
    // gleich das Rendering aus der Server-Antwort.
    if (!isBundle &&
        typeof window.optimisticLineFromBuyButton === 'function' &&
        typeof window.optimisticShowNewCart === 'function') {
      var optiMain = window.optimisticLineFromBuyButton(String(items[0].id), button && button.dataset ? button.dataset.name : '', 1);
      if (optiMain) {
        var optiLines = [optiMain];
        var hasFree = items.some(function (it) { return it.properties && it.properties['_mf_bundle_role'] === 'free'; });
        if (hasFree && typeof window.optimisticGuideLine === 'function') {
          optiLines.push(window.optimisticGuideLine());
        }
        window.optimisticShowNewCart(optiLines);
      }
    }

    // Neues Bundle/Produkt ERSETZT den Warenkorb: vorher komplett leeren, damit
    // z.B. beim Wechsel von kleinem zu großem Bundle die vorherigen Positionen
    // nicht liegen bleiben. Nutzt window.cartClear (aus script.js), sonst den
    // direkten clear-Endpunkt als Fallback.
    var clearFirst;
    if (typeof window.cartClear === 'function') {
      clearFirst = window.cartClear();
    } else {
      clearFirst = fetch(cartRoot() + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      }).catch(function () {});
    }

    function postItems(list) {
      return fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: list })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        return response.json();
      });
    }

    return Promise.resolve(clearFirst)
      .then(function () {
        return postItems(items).catch(function (err) {
          // Fallback: ohne Gratis-Positionen erneut versuchen, damit das
          // Hauptprodukt nicht am (z.B. nicht verfügbaren) Gratis-Artikel scheitert.
          var withoutFree = items.filter(function (it) {
            return !(it.properties && it.properties['_mf_bundle_role'] === 'free');
          });
          if (withoutFree.length && withoutFree.length !== items.length) {
            return postItems(withoutFree);
          }
          throw err;
        });
      })
      .then(function (addJson) {
        // Echte Positionen sofort anzeigen (ein voller Roundtrip früher):
        // nach dem Leeren ist die add.js-Antwort der komplette Warenkorb.
        if (addJson && addJson.items && typeof window.renderCartFromAddedItems === 'function') {
          window.renderCartFromAddedItems(addJson.items);
        }
        // Hinweis: Der Bundle-Rabatt läuft jetzt über einen AUTOMATISCHEN
        // Rabatt in Shopify (greift beim Bundle von selbst). Das Theme wendet
        // KEINEN Rabattcode mehr an – so bleibt das Gutschein-Feld im Warenkorb
        // frei für eigene Kundencodes (z.B. 10%-Gutschein), die sich mit dem
        // automatischen Bundle-Rabatt kombinieren.
        if (typeof window.syncCartFromShopify === 'function') return window.syncCartFromShopify();
      })
      .then(function () {
        // Keine "hinzugefügt"-Meldung mehr – der Warenkorb öffnet sich beim
        // Hinzufügen automatisch, die Bestätigung ist dadurch sichtbar.
      })
      .catch(function (error) {
        console.error('pdp bundle add error:', error);
        // Optimistische Anzeige mit dem echten Server-Stand überschreiben
        if (typeof window.syncCartFromShopify === 'function') { try { window.syncCartFromShopify(); } catch (e) {} }
        if (typeof window.showToast === 'function') window.showToast('warenkorb konnte nicht aktualisiert werden');
      })
      .finally(function () {
        setMainLoading(button, false);
      });
  }

  function initPdpBundle() {
    var root = document.getElementById('pdp-bundle');
    if (!root) return;

    moveBundleIntoSlot(root);
    initBundleCountdown(root);

    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var options = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    if (!options.length) return;

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        setSelected(root, options, option.dataset.option || 'single');
      });
    });

    setSelected(root, options, root.dataset.selected || 'bundle');

    var mainAdd = document.getElementById('buy-add');
    if (mainAdd && mainAdd.dataset.pbxReady !== '1') {
      mainAdd.dataset.pbxReady = '1';
      mainAdd.addEventListener('click', function (event) {
        var activeRoot = document.getElementById('pdp-bundle');
        if (!activeRoot || mainAdd.disabled) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        addSelectedBundle(activeRoot, mainAdd);
      }, true);
    }

    var stickyAdd = document.getElementById('sticky-add');
    if (stickyAdd && stickyAdd.dataset.pbxReady !== '1') {
      stickyAdd.dataset.pbxReady = '1';
      stickyAdd.addEventListener('click', function (event) {
        var activeRoot = document.getElementById('pdp-bundle');
        var mainAddBtn = document.getElementById('buy-add');
        if (!activeRoot || !mainAddBtn) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        addSelectedBundle(activeRoot, mainAddBtn);
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpBundle);
  } else {
    initPdpBundle();
  }

  document.addEventListener('shopify:section:load', function () {
    var root = document.getElementById('pdp-bundle');
    if (root) root.dataset.ready = '';
    initPdpBundle();
  });
})();

